module.exports = __webpack_public_path__ + "Roboto-Bold.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Bold.eot
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Bold.eot
// module chunks = 3